// PaperReportPDF.js
import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// const styles = StyleSheet.create({
//   page: {
//     padding: 20,
//     fontSize: 12,
//   },
//   page1: {
//     display: "flex",
//     // justifyContent: "center",
//     alignItems: "center",
//     padding: 20,
//     fontSize: 12
//   },
//   titleText: {
//     margin: "15px",
//     fontSize: 15,
//     fontWeight: "bold"
//   },
//   section: {
//     marginBottom: 10,
//   },
//   table: {
//     display: "table",
//     width: "auto",
//     borderStyle: "solid",
//     borderWidth: 1,
//     borderRightWidth: 0,
//     borderBottomWidth: 0,
//   },
//   tableRow: {
//     flexDirection: "row",
//   },
//   tableColHeader: {
//     width: "33.33%",
//     borderStyle: "solid",
//     borderBottomWidth: 1,
//     borderRightWidth: 1,
//     backgroundColor: '#000',
//     color: '#fff',
//     padding: 5,
//   },
//   tableCol: {
//     width: "33.33%",
//     borderStyle: "solid",
//     borderBottomWidth: 1,
//     borderRightWidth: 1,
//     padding: 5,
//   },
// });

// Document with auto page breaks

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 12,
  },
  page1: {
    display: "flex",
    alignItems: "center",
    padding: 20,
    fontSize: 12
  },
  titleText: {
    margin: "15px",
    fontSize: 15,
    fontWeight: "bold"
  },
  section: {
    marginBottom: 10,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },

  // For 3-column layout
  tableCol3: {
    width: "33.33%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 5,
  },
  tableColHeader3: {
    width: "33.33%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    backgroundColor: '#38761D',
    color: '#fff',
    padding: 5,
  },

  // For 2-column layout
  tableCol2: {
    width: "50%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 5,
  },
  tableColHeader2: {
    width: "50%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    backgroundColor: '#38761D',
    color: '#fff',
    padding: 5,
  },
});

export const PaperReportPDF = ({ data }) => (
  <Document>
    {console.log("DATA FOR PRINT:", data)}
    {data?.data !== undefined && data?.data !== null ? (
      <>
      <Page size="A4" style={styles.page1}>
        <Text style={styles.titleText}>Quizilla Pro Papers Report</Text>
        <Text style={styles.titleText}>Total Papers Generated: {data?.data?.totalPapers[0].totalPapers}</Text>
        <Text style={styles.titleText}>Total Papers Generated Board Wise</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader3}>Board</Text>
            <Text style={styles.tableColHeader3}>Region</Text>
            <Text style={styles.tableColHeader3}>Total Papers Generated</Text>
          </View>
          {data?.data?.regSummary.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCol3}>{item.BoardName}</Text>
              <Text style={styles.tableCol3}>{item.RegionName}</Text>
              <Text style={styles.tableCol3}>{item.PaperCount}</Text>
            </View>
          ))}

        </View>
      </Page>

      {data?.data?.isFilterApplied === false && (
        <>
          {data?.data?.camSummary?.some(item => item.BoardID === 2) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>Educators: Punjab Board Paper Generated Count as per Campus:</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.BoardID === 2).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>
          </Page>
      )}

          {data?.data?.camSummary?.some(item => item.BoardID === 4) && (
            <Page size="A4" style={styles.page}>
              <Text style={styles.titleText}>Educators: Sindh Board Paper Generated Count as per Campus:</Text>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <Text style={styles.tableColHeader2}>Campus Name:</Text>
                  <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
                </View>
                {data?.data?.camSummary?.filter(item => item.BoardID === 4).map((item, index) => (
                  <View style={styles.tableRow} key={index}>
                    <Text style={styles.tableCol2}>{item.campusName}</Text>
                    <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                  </View>
                ))}

              </View>
            </Page>
          )}
        </>
      )}

      {data?.data?.camSummary?.some(item => item.RegionID === 1) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>Educators: Total Papers Generated Region Wise</Text>
            <Text style={styles.titleText}>Center (ROC)</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.RegionID === 1).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>  
          </Page>
      )}

      {data?.data?.camSummary?.some(item => item.RegionID === 3) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>North (RON)</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.RegionID === 3).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>  
          </Page>
      )}
      {data?.data?.camSummary?.some(item => item.RegionID === 4) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>Southern Punjab (ROSP)</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.RegionID === 4).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>  
          </Page>
      )}

      {data?.data?.camSummary?.some(item => item.RegionID === 2) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>Faisalabad (ROF)</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.RegionID === 2).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>  
          </Page>
      )}

      {data?.data?.camSummary?.some(item => item.RegionID === 5) && (
          <Page size="A4" style={styles.page}>
            <Text style={styles.titleText}>South (ROS)</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={styles.tableColHeader2}>Campus Name:</Text>
                <Text style={styles.tableColHeader2}>Total Papers Generated:</Text>
              </View>
              {data?.data?.camSummary?.filter(item => item.RegionID === 5).map((item, index) => (
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.tableCol2}>{item.campusName}</Text>
                  <Text style={styles.tableCol2}>{item.PaperCount}</Text>
                </View>
              ))}

            </View>  
          </Page>
      )}

      </>
    ) : <>
      <Page size="A4" style={styles.page}>
        <Text>No Data Found!</Text>
      </Page>
    </>}
  </Document>
);
